<template>
  <div class="md:pb-20 lg:pb-20 relative z-index1">
    <img
      src="@/assets/images/line/Vector 7.png"
      alt="lineimg"
      class="m-auto px-4"
    />
    <!-- <div
      class="absolute insights-bg z-index--1 md:block lg:block md-hidden hidden"
    >
      <img
        src="@/assets/images/line/insig-line.svg"
        alt="bg-polygon"
        class="h-full w-full"
      />
    </div> -->
    <!--  <div class="absolute insights-bg-mob  md:hidden lg:hidden block">
      <img
        src="../../../../assets/images/line/inst-news-bg-mob.svg"
        alt="bg-polygon"
        class="h-full w-full"
      />
    </div> -->
    <div class="lg:pt-0 md:pt-0">
      <div class="md:w-10/12 lg:w-4/5 w-full mx-auto">
        <!-- <el-select v-model="value1" multiple placeholder="Select">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select> -->
        <!-- <div class="lg:mb-16 md:mb-12 mb-4">
          <div class="lg:flex md:flex justify-between items-center">
            <p class="title fsize36-16px-isg z-index--1">Featured Blogs</p>
       
          </div>
          <div class="md:pt-10 lg:pt-10 pt-0">
         
            <div
              class="grid md:grid-cols-4 lg:grid-cols-4 grid-cols-1 gap-x-8 md:gap-y-16 lg:gap-y-16"
            >
              <BlogCard />
              <BlogCard />
            </div>
          </div>
        </div> -->
        <div class="lg:flex md:flex justify-between items-center">
          <p
            class="title fsize36-16px-isg lg:font-normal md:font-normal font-bold"
          >
            Latest Blogs
          </p>
          <div class="lg:w-1/2 w-full lg:mb-0 md:mb-4 mb-0">
            <b-input
              placeholder="Search"
              v-model.trim="search"
              class="inp-search"
            ></b-input>
          </div>

          <!-- </div> -->
        </div>
        <div class="lg:flex justify-between items-center gap-8">
          <!-- <div class="lg:w-1/3 w-full lg:mb-0 md:mb-4 mb-0">
            <b-input
              placeholder="Search"
              v-model.trim="search"
              class="inp-search"
            ></b-input>
          </div> -->
          <div class="mt-4">
            <div
              class="grid lg:grid-cols-4 md:grid-cols-3 grid-cols-2 md:gap-4 lg:gap-4 gap-2 text-black"
            >
              <!-- <base-button
                class="ml-2 rounded-circle"
                size="sm"
                type="secondary"
                @click="handleClear"
                v-if="hasFiltered"
                ><feather-icon icon="XIcon" class="text-primary"></feather-icon
              ></base-button> -->

              <b-form-select
                v-model="selectedTopic"
                class="mr-4 border-2 border-primary lg:text-base md:text-base text-xs text-primary font-medium"
                ><b-form-select-option :value="null"
                  >{{ filters.length ? "Select " + filters[0].name : "" }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="filtertag1 in filter1"
                  :value="filtertag1._id"
                  :key="filtertag1._id"
                  >{{ filtertag1.name }}</b-form-select-option
                ></b-form-select
              >
              <b-form-select
                v-model="selectedCategories"
                class="mr-4 border-2 border-primary lg:text-base md:text-base text-xs text-primary font-medium"
                ><b-form-select-option :value="null"
                  >{{ filters.length ? "Select " + filters[1].name : "" }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="filtertag2 in filter2"
                  :value="filtertag2._id"
                  :key="filtertag2._id"
                  >{{ filtertag2.name }}</b-form-select-option
                ></b-form-select
              >
              <!-- <b-form-select
                v-model="selectedUsers"
                class="mr-4 border-2 border-primary lg:text-base md:text-base text-xs text-primary font-medium"
              >
                <b-form-select-option :value="null"
                  >{{ filters.length ? "Select " + filters[2].name : "" }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="filtertag3 in filter3"
                  :value="filtertag3._id"
                  :key="filtertag3._id"
                  >{{ filtertag3.name }}</b-form-select-option
                >
              </b-form-select> -->
              <multiselect
                class="mr-4 lricon"
                v-model="selectedUsers"
                :options="filter3"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                placeholder="From Whom"
                track-by="name"
                label="name"
                :preselect-first="false"
              >
              </multiselect>
              <b-form-select
                v-if="author.result.length !== 0"
                v-model="selectedAuthor"
                class="border-2 border-primary lg:text-base md:text-base text-xs text-primary font-medium mr-4"
              >
                <b-form-select-option :value="null"
                  >{{
                    author.result.length !== 0 ? "Select Author" : "No Author"
                  }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="author in filter4"
                  :value="author._id"
                  :key="author._id"
                  >{{ author.name }}</b-form-select-option
                >
              </b-form-select>

              <b-form-select
                v-if="doctor.result.length !== 0"
                v-model="selectedDoctor"
                class="border-2 border-primary lg:text-base md:text-base text-xs text-primary font-medium"
              >
                <b-form-select-option :value="null"
                  >{{
                    doctor.result.length !== 0
                      ? "Medically reviewed by"
                      : "No Doctor"
                  }}
                </b-form-select-option>
                <b-form-select-option
                  v-for="doctor in filter5"
                  :value="doctor._id"
                  :key="doctor._id"
                  >{{ doctor.name }}</b-form-select-option
                >
              </b-form-select>
            </div>
          </div>
        </div>
        <p
          class="text-end text-primary cursor-pointer fsize14 sm-fsize12 font-semibold hov-underline lg:mb-0 md:mb-0 mb-6"
          @click="handleClear"
        >
          Clear Filter
        </p>
        <!-- <div class="lg:flex md:flex justify-between items-center">
          <div class="w-4/5">A</div>
          <div class="w-1/5">B</div>
        </div> -->
        <div id="topSection">
          <p
            class="joinus-subtitle md:pt-10 lg:pt-10 pt-6 lg:mb-0 md:mb-0 mb-2 fsize24-14px"
          >
            You can narrow down the most relevant article for you by using the
            filters listed above.
          </p>
        </div>

        <div class="md:pt-10 lg:pt-10 pt-0" id="topSection">
          <div
            class="grid md:grid-cols-2 lg:grid-cols-3 grid-cols-1 lg:gap-8 md:gap-8 gap-8"
            v-if="categorywisepages.data.length !== 0"
          >
            <BlogItem
              v-for="item in categorywisepages.data"
              :key="item._id"
              :item="item"
              :category="item.pageCategory.name"
              :data="categorywisepages.data"
            />
          </div>
          <div class="" v-else>
            <p class="text-center fsize20 text-primary">No data</p>
          </div>
        </div>
        <div class="flex lg:mt-8 md:mt-8 mt-4 flex-wrap justify-content-end">
          <b-pagination
            @change="handlePageChange"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            size="lg"
          ></b-pagination>
          <!-- <b-pagination
            @change="handlePageChange"
            pills
            v-model="currentPage"
            :total-rows="row"
            :per-page="perPage"
            size="lg"
            class="ml-auto flex flex-wrap"
          ></b-pagination> -->
        </div>

        <p
          class="joinus-subtitle md-fsize18 md:pt-10 lg:pt-10 pt-4 fsize24-14px"
        >
          If you would like to recommended an article to curate or wish to
          author an article for us, we will be be happy to publish. Please write
          to us at
          <a target="_blank" href="mailto:info@caregiversaathi.co.in"
            >info@caregiversaathi.co.in
          </a>
        </p>
        <!-- <div class="flex">
          <base-button
            outline
            type="primary"
            class="
              md:px-10
              lg:px-10
              px-6
              md:py-3
              lg:py-3
              py-1
              fs16700
              border-2
              mx-auto
            "
            >View more</base-button
          >
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import BlogItem from "./BlogItem.vue";
import { mapState } from "vuex";

import _ from "lodash";
import Multiselect from "vue-multiselect";
import BlogCard from "./BlogCard1.vue";

export default {
  components: {
    BlogCard,
    BlogItem,
    Multiselect,
  },
  data() {
    return {
      value: null,
      opt: ["list", "of", "options", "Hiiiee"],
      // options: [
      //   { value: null, text: "Please select an option" },
      //   { value: "a", text: "Primary Caregiver" },
      //   { value: "b", text: "Wellwisher" },
      //   { value: "c", text: "Long Distance Caregiver" },
      // ],
      value1: [],
      search: "",
      filter1: [],
      filter2: [],
      filter3: [],
      filter4: [],
      filter5: [],
      filteredData: [],
      categoryId: null,
      selectedTopic: null,
      selectedUsers: null,
      selectedAuthor: null,
      selectedDoctor: null,
      selectedCategories: null,
      currentPage: 1,
      perPage: 12,
      offset: 12,
      rows: 0,
      tagid: [],
      oldTagTopic: "",
      oldTagCategories: "",
      oldTagUser: [],
    };
  },
  watch: {
    search: {
      handler: _.debounce(async function (val) {
        let payload = {
          id: this.categoryId,
          offset: 0,
          search: val.trim(),
          // isNotLoggedIn: this.isNotLoggedIn(),
          updatedAt: true,
        };
        if (this.tagid.length > 0) {
          Object.assign(payload, { tagid: this.tagid });
        }
        if (this.selectedAuthor) {
          Object.assign(payload, { authors: this.selectedAuthor });
        }
        if (this.selectedDoctor) {
          Object.assign(payload, { doctors: this.selectedDoctor });
        }
        this.currentPage = 1;
        let filteredAPIData = await this.$store.dispatch(
          "cms/GetPagesbyCategoryForBlog",
          payload
        );

        this.filteredData = filteredAPIData.data;
        this.rows = Number(this.filteredData.totalPages);
      }, 500),
    },
    async selectedTopic(val) {
      // if (this.tagid.length > 3) {
      //   this.tagid = [];
      // }

      this.tagid = this.tagid.filter((tag) => tag !== this.oldTagTopic);
      this.oldTagTopic = val;
      // console.log(val);
      if (val !== null) {
        this.tagid.unshift(val);
      }
      if (val || val === null) {
        let payload = {
          offset:
            this.currentPage >= 1
              ? (this.currentPage - 1) * this.offset
              : this.currentPage,
          id: this.categoryId,
          // isNotLoggedIn: this.isNotLoggedIn(),
          updatedAt: true,
          // tagid: this.tagid,
        };
        if (this.tagid.length > 0) {
          Object.assign(payload, { tagid: this.tagid });
        }
        if (this.selectedAuthor) {
          Object.assign(payload, { authors: this.selectedAuthor });
        }
        if (this.selectedDoctor) {
          Object.assign(payload, { doctors: this.selectedDoctor });
        }
        if (this.search !== "")
          Object.assign(payload, { search: this.search.trim() });
        // console.log(payload);
        let filteredAPIData = await this.$store.dispatch(
          "cms/GetPagesbyCategoryForBlog",
          payload
        );
        // this.currentPage = 1;
        this.filteredData = filteredAPIData.data;
        // console.log(this.filteredData.totalPages);
        this.rows = Number(this.filteredData.totalPages);

        this.loadData();
      }
    },
    async selectedCategories(val) {
      // if (this.tagid.length > 3) {
      //   this.tagid = [];
      // }
      this.tagid = this.tagid.filter((tag) => tag !== this.oldTagCategories);
      this.oldTagCategories = val;
      if (val !== null) {
        this.tagid.unshift(val);
      }
      if (val || val === null) {
        let payload = {
          offset:
            this.currentPage >= 1
              ? (this.currentPage - 1) * this.offset
              : this.currentPage,
          id: this.categoryId,
          // isNotLoggedIn: this.isNotLoggedIn(),
          updatedAt: true,
          // tagid: this.tagid,
        };
        if (this.tagid.length > 0) {
          Object.assign(payload, { tagid: this.tagid });
        }
        if (this.selectedAuthor) {
          Object.assign(payload, { authors: this.selectedAuthor });
        }
        if (this.selectedDoctor) {
          Object.assign(payload, { doctors: this.selectedDoctor });
        }
        if (this.search !== "")
          Object.assign(payload, { search: this.search.trim() });
        // console.log(payload);
        let filteredAPIData = await this.$store.dispatch(
          "cms/GetPagesbyCategoryForBlog",
          payload
        );
        this.filteredData = filteredAPIData.data;
        this.rows = Number(this.filteredData.totalPages);

        this.loadData();
      }
    },
    async selectedUsers(val) {
      // console.log(val);
      // if (this.tagid.length > 3) {
      //   this.tagid = [];
      // }

      // console.log(val);
      let tagIdData = val.map((tag) => tag._id);

      // this.tagid = this.tagid.filter((tag) => tag !== this.oldTagUser);
      this.tagid = this.tagid.filter((tag) => !this.oldTagUser.includes(tag));
      this.oldTagUser = tagIdData;
      if (tagIdData !== null) {
        // this.tagid.unshift(tagIdData);
        this.tagid = [...this.tagid, ...tagIdData];
      }
      // console.log(this.tagid);
      if (val || val === null) {
        let payload = {
          offset:
            this.currentPage >= 1
              ? (this.currentPage - 1) * this.offset
              : this.currentPage,
          id: this.categoryId,
          // isNotLoggedIn: this.isNotLoggedIn(),
          updatedAt: true,
          // tagid: this.tagid,
        };
        if (this.tagid.length > 0) {
          Object.assign(payload, { tagid: this.tagid });
        }
        if (this.selectedAuthor) {
          Object.assign(payload, { authors: this.selectedAuthor });
        }
        if (this.selectedDoctor) {
          Object.assign(payload, { doctors: this.selectedDoctor });
        }
        if (this.search !== "")
          Object.assign(payload, { search: this.search.trim() });
        // console.log(payload);
        let filteredAPIData = await this.$store.dispatch(
          "cms/GetPagesbyCategoryForBlog",
          payload
        );
        this.filteredData = filteredAPIData.data;
        this.rows = Number(this.filteredData.totalPages);
        this.loadData();
      }
    },
    async selectedAuthor(val) {
      // if (this.tagid.length > 3) {
      //   this.tagid = [];
      // }
      // this.tagid = this.tagid.filter((tag) => tag !== this.oldTagUser);
      // this.oldTagUser = val;
      // if (val !== null) {
      //   this.tagid.unshift(val);
      // }

      if (val || val === null) {
        let payload = {
          offset:
            this.currentPage >= 1
              ? (this.currentPage - 1) * this.offset
              : this.currentPage,
          id: this.categoryId,
          // isNotLoggedIn: this.isNotLoggedIn(),
          updatedAt: true,
          // tagid: this.tagid,
        };
        if (this.tagid.length > 0) {
          // console.log(this.tagid);
          Object.assign(payload, { tagid: this.tagid });
        }
        if (this.selectedAuthor) {
          Object.assign(payload, { authors: this.selectedAuthor });
        }
        if (this.selectedDoctor) {
          Object.assign(payload, { doctors: this.selectedDoctor });
        }
        if (this.search !== "")
          Object.assign(payload, { search: this.search.trim() });
        // console.log(payload);
        let filteredAPIData = await this.$store.dispatch(
          "cms/GetPagesbyCategoryForBlog",
          payload
        );
        this.filteredData = filteredAPIData.data;
        this.rows = Number(this.filteredData.totalPages);
        this.loadData();
      }
    },
    async selectedDoctor(val) {
      if (val || val === null) {
        let payload = {
          offset:
            this.currentPage >= 1
              ? (this.currentPage - 1) * this.offset
              : this.currentPage,
          id: this.categoryId,
          // isNotLoggedIn: this.isNotLoggedIn(),
          updatedAt: true,
          // tagid: this.tagid,
        };
        if (this.tagid.length > 0) {
          // console.log(this.tagid);
          Object.assign(payload, { tagid: this.tagid });
        }
        if (this.selectedAuthor) {
          Object.assign(payload, { authors: this.selectedAuthor });
        }
        if (this.selectedDoctor) {
          Object.assign(payload, { doctors: this.selectedDoctor });
        }
        if (this.search !== "")
          Object.assign(payload, { search: this.search.trim() });
        // console.log(payload);
        let filteredAPIData = await this.$store.dispatch(
          "cms/GetPagesbyCategoryForBlog",
          payload
        );
        this.filteredData = filteredAPIData.data;
        this.rows = Number(this.filteredData.totalPages);
        this.loadData();
      }
    },
    categorywisepages(val) {
      if (this.tagid.length > 0) {
        this.categorywisepages = { ...this.categorywisepages };
      }
    },
  },
  computed: {
    ...mapState("cms", {
      pageCategories: "pageCategories",
      filtertags: "filtertags",
      filters: "filters",
      pages: "pages",
      categorywisepages: "categorywisepages",
    }),
    ...mapState("cmsAuthor", {
      author: "author",
    }),
    ...mapState("doctor", {
      doctor: "doctor",
    }),
    ...mapState("auth", { user: "user" }),
    ...mapState("auth", { getUserByUserId: "getUserByUserId" }),
    // displayedPages() {
    //   return this.pages.slice(
    //     (this.currentPage - 1) * this.perPage,
    //     this.currentPage * this.perPage
    //   );
    // },
    total_row() {
      return this.pages.length;
    },
  },
  methods: {
    async handlePageChange(value) {
      this.currentPage = value;
      let payload = {
        offset:
          this.currentPage >= 1
            ? (this.currentPage - 1) * this.offset
            : this.currentPage,
        id: this.categoryId,
        // isNotLoggedIn: this.isNotLoggedIn(),
        updatedAt: true,
        // tagid: this.tagid,
      };
      if (this.tagid.length > 0) {
        Object.assign(payload, { tagid: this.tagid });
      }
      // this.filteredData = await this.$store.dispatch(
      //   "cms/getpagebycategory",
      //   payload
      // );
      if (this.selectedAuthor) {
        Object.assign(payload, { authors: this.selectedAuthor });
      }
      if (this.selectedDoctor) {
        Object.assign(payload, { doctors: this.selectedDoctor });
      }

      if (this.search !== "")
        Object.assign(payload, { search: this.search.trim() });
      let filteredAPIData = await this.$store.dispatch(
        "cms/GetPagesbyCategoryForBlog",
        payload
      );
      this.filteredData = filteredAPIData.data;
      this.rows = Number(this.filteredData.totalPages);
      let el = document.getElementById("topSection");
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    },
    handleClick(name) {
      this.$router.push({ name: name });
      this.toggleNavbar();
    },
    handleClear() {
      this.selectedTopic = null;
      this.selectedUsers = null;
      this.selectedCategories = null;
      this.selectedAuthor = null;
      this.selectedDoctor = null;
      this.loadData();
    },
    async loadData() {
      let loader = this.$loading();
      try {
        let categoryUsers = [],
          categoryTopics = [],
          category = [];
        if (this.selectedUsers != null)
          categoryUsers = this.categorywisepages.data.filter((x) => {
            return x.tags.includes(this.selectedUsers);
          });
        if (this.selectedCategories != null)
          category = this.categorywisepages.data.filter((x) => {
            return x.tags.includes(this.selectedCategories);
          });
        if (this.selectedTopic != null)
          categoryTopics = this.categorywisepages.data.filter((x) => {
            return x.tags.includes(this.selectedTopic);
          });

        let combinedFilter = [...categoryUsers, ...category, ...categoryTopics];
        this.filteredData = _.uniq(combinedFilter);

        loader.close();
      } catch (error) {
        loader.close();
      }
    },
    async init() {
      await this.$store.dispatch("cms/getPageCategories");

      this.pageCategories.forEach((element) => {
        if (element.route.includes("blogs")) this.categoryId = element._id;
      });
      await this.$store.dispatch("cms/getTagsbyCategory", {
        categoryPage: this.categoryId,
      });
      await this.$store.dispatch("cms/getfilterbycategory", {
        categoryPage: this.categoryId,
      });
      this.filter1 = this.filtertags.filter(
        (x) => x.filter._id == this.filters[0]._id
      );
      this.filter2 = this.filtertags.filter(
        (x) => x.filter._id == this.filters[1]._id
      );
      this.filter3 = this.filtertags.filter(
        (x) => x.filter._id == this.filters[2]._id
      );
      let filteredAPIData = await this.$store.dispatch(
        "cms/GetPagesbyCategoryForBlog",
        {
          id: this.categoryId,
          limit: 12,
          // // isNotLoggedIn: this.isNotLoggedIn(),
          updatedAt: true,
          // membership: "650063c5e37fa400126fc742",
        }
      );

      this.filteredData = filteredAPIData.data;
      this.rows = Number(this.filteredData.totalPages);

      let filteredAuthorAPIData = await this.$store.dispatch(
        "cmsAuthor/getAuthor"
      );
      this.filter4 = this.author.result;

      let filteredDoctorAPIData = await this.$store.dispatch(
        "doctor/getDoctor"
      );
      this.filter5 = this.doctor.result;
      // console.log(this.doctor);
      // console.log(
      //   this.filteredData,
      //   "  changes    this.filteredData      this.filteredData      this.filteredData"
      // );
    },
    isNotLoggedIn() {
      if (sessionStorage.getItem("token")) {
        return false;
      } else {
        return true;
      }
    },
  },
  async mounted() {
    // await this.$store.dispatch("auth/getUserByUserId", {
    //   userId: this.user._id,
    // });
    // console.log(
    //   this.categorywisepages,
    //   "categorywisepages.datacategorywisepages.datacategorywisepages.data"
    // );
    // console.log(this.filtertags, "filtertagsfiltertagsfiltertags");
    // console.log(this.filters, "filtersfiltersfilters");
    this.init();
    if (Object.keys(this.user).length !== 0) {
      let getUserPayload = {
        userId: this.user._id,
      };
      const getUser = await this.$store.dispatch(
        "auth/getUserByUserId",
        getUserPayload
      );
    }
  },
};
</script>
<style>
.lricon .multiselect__select {
  right: 12px !important;
  top: 5px !important;
}
.inp-search {
  border-radius: 50px !important;
  border: 1px solid #4f0a4b !important;
  height: 47px !important;
}

.bg-insight-cs .multiselect__tags {
  border: 1px solid #4f0a4b;
  border-radius: 25px;
  height: auto;
  width: 275px;
}

.bg-insight-cs .multiselect__tag {
  background: #4f0a4b;
  color: #fff;
  margin-bottom: 1px;
}
.bg-insight-cs .multiselect__option--highlight {
  background: #4f0a4b;
  color: #fff;
}
.bg-insight-cs
  .multiselect__option--selected.multiselect__option--highlight:after {
  background: #4f0a4b;
  color: #fff;
}
.bg-insight-cs .multiselect__option--highlight:after {
  display: none;
}
.bg-insight-cs .multiselect__option--selected.multiselect__option--highlight {
  background: #4f0a4b;
  color: #fff;
}

@media (max-width: 641px) {
  .inp-search {
    height: 40px !important;
  }
  .bg-insight-cs .multiselect__tags {
    border: 1px solid #4f0a4b;
    border-radius: 25px;
    height: auto;
    width: auto;
  }
  .lricon .multiselect__select {
    right: 1px !important;
    top: 1px !important;
  }
}
</style>
